export default __webpack_public_path__ + "static/clean-ingredients_real-people_Marcos-Spaziani-17dd8ee578831740e842b8dc6012d59c.png";